export const ErrorLogger = (src: string, err: { message: string }): void => {
  console.log(`Error occured from ${src} : ${err.message}`);
};